import { render, staticRenderFns } from "./editLabel.vue?vue&type=template&id=140deeac&scoped=true&"
import script from "./editLabel.vue?vue&type=script&lang=js&"
export * from "./editLabel.vue?vue&type=script&lang=js&"
import style0 from "./editLabel.vue?vue&type=style&index=0&id=140deeac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140deeac",
  null
  
)

export default component.exports